// extracted by mini-css-extract-plugin
module.exports = {"items":"styles_items__1aguj","item":"styles_item__1vfTG"};